import functions from "../../../util/functions";
import { ProgresNBack } from "../../styles/styles";
import "./style.css";

const VendaDetalhamento = (props) => {


	return (
		<div className="col-12 ">
			{props.listVendasPorDia.length > 0 && (
				<div className="card detail-container">
					<div className="border-bottom">
						<h2>Vendas do período - Valor líquido</h2>
						<span>Resumo do mês</span>
					</div>

					<div className="row mt-3">
						<div className="col-6 col-lg-4 border-right">
							<h6>Valor total vendas</h6>
							<h4>{functions.strToCurrency(props.listVendasPorDia[0].total)}</h4>
						</div>
						<div className="col-6 col-lg-4 border-right">
							<h6>Número de vendas</h6>
							<h4>{props.listVendasPorDia[0].qtdetotalvendas}</h4>
						</div>
						<div className="col-6 col-lg-4 border-right">
							<h6>Ticket Médio</h6>
							<h4>{functions.strToCurrency(props.listVendasPorDia[0].ticketmediototal)}</h4>
						</div>
					</div>
				</div>
			)}

			{props.listComparativo.length > 0 && (
				<div className="card detail-container">
					<div className="border-bottom">
						<h2>Comparativo - Valor Líquido</h2>
					</div>

					<div className="row mt-3">
						<div className="col-6 col-lg-4 border-right">
							<div>
								<h6>Mês Anterior</h6>
								<h4>{functions.strToCurrency(props.listComparativo[0].mes_anterior1)}</h4>
							</div>
							<div>
								<h6>Média diária</h6>
								<h4>{functions.strToCurrency(props.listComparativo[0].mediamesanterior)}</h4>
							</div>
						</div>
						<div className="col-6 col-lg-4 border-right">
							<div>
								<h6>Mês Atual</h6>
								<h4>{functions.strToCurrency(props.listComparativo[0].este_mes)}</h4>
							</div>
							<div>
								<h6>Média diária</h6>

								<h4>{functions.strToCurrency(props.listComparativo[0].mediamesatual)}</h4>
							</div>
						</div>
						<div className="col-6 col-lg-4 border-right">
							<h6>Hoje</h6>

							<h4>{functions.strToCurrency(props.listComparativo[0].hoje)}</h4>

							<h6>Ontem</h6>
							<h4>{functions.strToCurrency(props.listComparativo[0].ontem)}</h4>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default VendaDetalhamento;
